import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["assignEl", "assignElBtn", "closeAssignElBtn"]

  toggleAssignView(event) {
    event.preventDefault()

    if (this.assignElTarget.classList.contains('d-none')) {
      // Show the assignment form
      this.assignElTarget.classList.remove('d-none')
      if (this.assignElBtnTarget) {
        this.assignElBtnTarget.classList.add('d-none')
      }
      if (this.closeAssignElBtnTarget) {
        this.closeAssignElBtnTarget.classList.remove('d-none')
      }
    } else {
      // Hide the assignment form
      this.assignElTarget.classList.add('d-none')
      if (this.assignElBtnTarget) {
        this.assignElBtnTarget.classList.remove('d-none')
      }
      if (this.closeAssignElBtnTarget) {
        this.closeAssignElBtnTarget.classList.add('d-none')
      }
    }
  }
}
